import PropTypes from 'prop-types';

const { number, string, shape } = PropTypes;

export default shape({
  id: string,
  time: number,
});
